export default "/assets/images/badge-02.26d0a26348eb292e.png";